import React, { useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import Scene from '../../structural/scene/scene02'; 
import SettingsMenu from '../../structural/screen/settingsMenu02';
import SponsortsBar from '../../structural/screen/sponsorsBar';
import Controls from '../../structural/controls/cameraControls';
import { PerspectiveCamera } from '@react-three/drei';

import 
{ 
  createSpacingMatrix, 
  createGridMatrix,
  calculatePivot,
  createHeightMatrix,
  createNodesMatrix,
  createColumnsMatrixMetalic,
  updateColumnsMatrixMetalic,
} from '../../structural/helpers';

const MetalicasSencillas = () => 
  {
    const [xAxis, setXAxis] = useState(3); // Eje X por defecto de 3
    const [zAxis, setZAxis] = useState(2); // Eje Y por defecto de 2
    const [floors, setFloors] = useState(1); // Número de pisos
    const [selectedFloor, setSelectedFloor] = useState(0);
    const [intersectionSpacing, setIntersectionSpacing] = useState(1); // Espacio entre intersecciones (por defecto 1 metro)
  
    const [spacingMatrix, setSpacingMatrix] = useState([]);
    const [heightMatrix, setHeightMatrix] = useState([]);
    const [totalHeight, setTotalHeight] = useState([]);
  
    const [gridPoints, setGridPoints] = useState([]);
    const [pivotPoint, setPivotPoint] = useState({ x: 0, y: 0, z: 0 });
  
    const [nodes, setNodes] = useState({ x: 0, y: 0, z: 0 });
  
    const [columnsMatrix, setColumnMatrix] = useState([]);
  
    const [selectedSpacing, setSelectedSpacing] = useState('A1 - B1');
    const [minimumColumnProfile, setMinimumColumnProfile] = useState(23);

 
     // Actualizar la matriz de altura
     useEffect(() => 
    {
      const prevMatrix  = []
      let matrix1 = createHeightMatrix(floors, prevMatrix);
  
      setHeightMatrix(matrix1);
      setTotalHeight(Number(matrix1.slice(0, floors).reduce((acc, curr) => acc + parseFloat(curr.height), 0)).toFixed(2));
      
    }, [floors]);
  
    // Actualizar la matriz cuando cambien los ejes, sin perder valores previos
    useEffect(() => 
    {
      setSpacingMatrix((prevMatrix) => createSpacingMatrix(xAxis, zAxis, prevMatrix));
    }, [xAxis, zAxis]);
  
    //Se crea la Matrix de los ejes
    useEffect(() => 
    {
      setGridPoints(createGridMatrix(spacingMatrix, xAxis, zAxis));
      setNodes(createNodesMatrix(spacingMatrix, xAxis, zAxis, heightMatrix));    
    }, [spacingMatrix, xAxis, zAxis, heightMatrix, floors]);
   
    //Cálculo del Pivot
    useEffect(() => 
    {
      if (gridPoints.length === 0) return;
  
      // Calcular pivot con la nueva matriz de puntos
      const pivot = calculatePivot(gridPoints, totalHeight/2, pivotPoint);
      setPivotPoint(pivot);
  
    }, [gridPoints, totalHeight ]);
      
    // Generar la matriz y publicarla en la consola cuando cambien los ejes
    useEffect(() => 
    {
      let matrix1;
      if(columnsMatrix.length === 0)
      {
        matrix1 = createColumnsMatrixMetalic(gridPoints, heightMatrix);   
      }
      else
      {
        matrix1 = updateColumnsMatrixMetalic(gridPoints, heightMatrix, columnsMatrix);   
      }
  
      setColumnMatrix(matrix1);     
      
    }, [xAxis, zAxis, floors, gridPoints, heightMatrix]);   
     
    return (
      <div className="relative h-screen w-full">
        <div className="absolute top-0 left-0 h-full w-3/4">
          <Canvas shadows>
            {pivotPoint.x && pivotPoint.y && pivotPoint.z &&
              <Controls 
                pivot={pivotPoint}
              /> 
            }
  
            <PerspectiveCamera 
              makeDefault
              position={[0, 8, 12]}
              fov={75}
            />
            
            <Scene
              xAxis={xAxis}
              zAxis={zAxis}
              floors={floors} 
              intersectionSpacing={intersectionSpacing}
              selectedFloor={selectedFloor}
              pivotPoint =  {pivotPoint}
              gridPoints = {gridPoints}
  
              spacingMatrix={spacingMatrix}
              heightMatrix = {heightMatrix}
  
              nodes  = {nodes}
  
              columnsMatrix = {columnsMatrix}
  
              selectedSpacing = {selectedSpacing}
              setSelectedSpacing = {setSelectedSpacing}
            />
          </Canvas>
        </div>
        
        <SettingsMenu
          xAxis={xAxis}
          zAxis={zAxis}
          floors={floors} 
          setFloors={setFloors}
          intersectionSpacing={intersectionSpacing}
          setXAxis={setXAxis}
          setZAxis={setZAxis}
          setIntersectionSpacing={setIntersectionSpacing}
          selectedFloor={selectedFloor} 
          setSelectedFloor={setSelectedFloor} 
  
          spacingMatrix={spacingMatrix} 
          setSpacingMatrix={setSpacingMatrix}         
  
          selectedSpacing = {selectedSpacing}

          minimumColumnProfile = {minimumColumnProfile}
          setMinimumColumnProfile = {setMinimumColumnProfile}
        />

       
      </div>
    );
  };
  
  export default MetalicasSencillas;